import React from "react";

export const About = () => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-4">
            <img
              src="img/elana-headshot-medium-crop.jpg"
              className="img-responsive img-rounded w-100"
              alt="Dr. Elana Kagan headshot"
            />
          </div>
          <div className="col-xs-12 col-md-8">
            <div className="about-text">
              <h2>Evidence-based Treament and Expert Care</h2>
              <div className="about-content">
                <p>
                  As a child psychologist specializing in evidence-based
                  treatments, I bring extensive clinical expertise to every
                  patient I work with. In addition to my independent practice, I
                  am a psychologist at the Center for Anxiety and Behavior
                  Therapy.
                </p>
                <p className="no-decoration">
                  My therapeutic approach centers on working collaboratively
                  with children, adolescents, and young adults. I also provide
                  parent coaching to help families develop supportive strategies
                  for managing these conditions at home. I invite you to reach
                  out for a complimentary phone consultation to determine if my
                  practice aligns with your family's needs.
                </p>
                <p>
                  My treatment methodology primarily employs cognitive behavior
                  therapy (CBT), teaching patients practical coping strategies
                  to manage symptoms while gradually approaching challenging
                  situations. When appropriate, I incorporate other
                  evidence-based approaches such as Acceptance and Commitment
                  Therapy (ACT) and Dialectical Behavior Therapy (DBT) to create
                  a comprehensive treatment plan tailored to each individual's
                  unique needs.
                </p>
              </div>
              <h3>Areas of Expertise</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>Generalized Anxiety Disorder</li>
                    <li>Social Anxiety</li>
                    <li>Separation Anxiety</li>
                    <li>OCD</li>
                    <li>Specific Phobies & Panic</li>
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>ADHD</li>
                    <li>Depression & Mood Concerns</li>
                    <li>Behavioral Concerns</li>
                    <li>Parent Coaching & Family Support</li>
                    <li>Tic Disorders & Body Focused Repetitive Behaviors</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
